<template>
  <div class="thumbnail-slide"
    :style="{
      width: size + 'px',
      height: size * viewportRatio + 'px',
    }"
  >
    <div
      class="elements"
      :style="{
        width: VIEWPORT_SIZE + 'px',
        height: VIEWPORT_SIZE * viewportRatio + 'px',
        transform: `scale(${scale})`,
      }"
      v-if="visible"
    >
      <div class="background" :style="backgroundStyle"></div>

      <ViewerElement
          v-for="(element, elementIndex) in slide.elements.filter(element => !element.canvasHide && element.type !== 'dragdrop')"
          :key="element.id"
          :elementInfo="element"
          :elementIndex="elementIndex + 1"
      />


    </div>
    <div class="placeholder" v-else>Loading ...</div>
  </div>
</template>

<script lang="ts" setup>
import {computed, onMounted, PropType, provide, ref} from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import {PPTElement, Slide} from '@/types/slides'
import { injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'

import ThumbnailElement from './ThumbnailElement.vue'
import ViewerElement from "@/views/Viewer/Canvas/ViewerElement.vue";
import appCss from "@/assets/styles/theme.css";

const props = defineProps({
  slide: {
    type: Object as PropType<Slide>,
    required: true,
  },
  size: {
    type: Number,
    required: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  library: {
    type: Boolean
  }
})

const { viewportRatio } = storeToRefs(useSlidesStore())

const background = computed(() => props.slide.background)
const { backgroundStyle } = useSlideBackgroundStyle(background)

const scale = computed(() => props.size / VIEWPORT_SIZE)
provide(injectKeySlideScale, scale)
</script>

<style lang="scss" scoped>
.thumbnail-slide {
  background-color: #fff;
  overflow: hidden;
  user-select: none;
}
.elements {
  transform-origin: 0 0;
}
.background {
  width: 100%;
  height: 100%;
  background-position: center;
  position: absolute;
  z-index: -1;
}
.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


</style>
